import { Suspense } from 'react';
import { Await, useLoaderData, useLocation } from 'react-router-dom';
import {
  ActivityTemplate,
  Task,
  Intro,
  TemplateTag,
  TemplateStatus,
} from '../models';
import Spinner from '../share/Spinner';
import TemplateDetail from './TemplateDetail';
import { splitTasks } from '../utils';

type ResolvedData = {
  tasks: Task[];
  intros: Intro[];
  tagOptions: TemplateTag[];
};
export default function TemplateDetailContainer({
  send,
  refreshTags,
}: {
  send: (formData: FormData) => Promise<any>;
  refreshTags: () => Promise<TemplateTag[]>;
}) {
  const location = useLocation();
  const deferredData = useLoaderData() as { result: ResolvedData };
  const template: ActivityTemplate = location.state?.template || {
    name: '',
    description: '',
    duration: 0,
    imageUrl: '',
    status: TemplateStatus.DRAFT,
    tag: null,
  };

  const wrapFunc = ({ tasks, intros, tagOptions }: ResolvedData) => {
    const { moduleIds, closeModuleId } = splitTasks(tasks);
    return (
      <TemplateDetail
        template={template}
        moduleIds={moduleIds}
        closeModuleId={closeModuleId}
        intros={intros}
        tagOptions={tagOptions}
        send={send}
        refreshTags={refreshTags}
      />
    );
  };

  return (
    <Suspense fallback={<Spinner />}>
      <Await resolve={deferredData.result}>{wrapFunc}</Await>
    </Suspense>
  );
}
